import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";
import Lock from "@material-ui/icons/Lock";
import Public from "@material-ui/icons/Public";

const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: 345
  },
  media: {
    height: 140
  },
  count: {
    position: "absolute",
    right: 5
  },
  liveBadge: {
    border: "1px solid red",
    borderRadius: "5px",
    color: "red",
    padding: "3px",
    position: "absolute",
    left: "3px",
    top: "3px",
    lineHeight: "1"
  },
  name: {
    display: "flex",
    alignItems: "center"
  },
  icon: {
    margin: theme.spacing(1)
  }
}));
/*
      component={Link}
      to={"/rooms/" + room.roomId}
*/
export default function RoomCard({ room }) {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardActionArea component={Link} to={"/rooms/" + room.roomId}>
        <CardMedia
          className={classes.media}
          image="https://images.unsplash.com/photo-1519681393784-d120267933ba?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&w=1000&q=80"
          title="Contemplative Reptile"
        >
          <Typography className={classes.count} variant="caption">
            {room.userCount} Users
          </Typography>
          {room.live && (
            <Typography className={classes.liveBadge} variant="overline">
              Live
            </Typography>
          )}
        </CardMedia>
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="h2"
            className={classes.name}
          >
            {room.name}{" "}
            {(room.private && <Lock className={classes.icon} />) || (
              <Public className={classes.icon} />
            )}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p">
            Lizards are a widespread group of squamate reptiles, with over 6,000
            species, ranging across all continents except Antarctica
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          size="small"
          color="primary"
          component={Link}
          to={"/rooms/" + room.roomId}
        >
          Join
        </Button>
        <Button size="small" color="primary">
          Learn More
        </Button>
      </CardActions>
    </Card>
  );
}
